// Centralized date formatting utilities for dd/mm/yyyy format

export const formatDateForDisplay = (dateString: string | undefined): string => {
    if (!dateString) return '';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '';
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    } catch (e) {
        return '';
    }
};

export const formatDateForInput = (dateString: string | undefined): string => {
    if (!dateString) return '';
    
    // Clean the date string (remove extra spaces and characters)
    const cleanDate = dateString.trim().replace(/[^\d\/\-]/g, '');
    
    // Handles dd/mm/yyyy
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(cleanDate)) {
        const [day, month, year] = cleanDate.split('/');
        return `${year}-${month}-${day}`;
    }
    
    // Handles dd/mm/yyyy with possible spaces
    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(cleanDate)) {
        const [day, month, year] = cleanDate.split('/').map(part => part.padStart(2, '0'));
        return `${year}-${month}-${day}`;
    }
    
    // Handles yyyy-mm-dd (already correct format for HTML input)
    if (/^\d{4}-\d{2}-\d{2}$/.test(cleanDate)) {
        return cleanDate;
    }
    
    // Handles yyyy-mm-dd with possible spaces
    if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(cleanDate)) {
        const [year, month, day] = cleanDate.split('-').map(part => part.padStart(2, '0'));
        return `${year}-${month}-${day}`;
    }
    
    // Try to parse with Date object as fallback
    try {
        const date = new Date(cleanDate);
        if (!isNaN(date.getTime())) {
            return date.toISOString().split('T')[0];
        }
    } catch (e) {
        // Invalid date
    }
    
    return '';
};

export const formatVietnameseDate = (dateString: string | undefined): string => {
    if (!dateString) return '';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '';
        return `ngày ${date.getDate()} tháng ${date.getMonth() + 1} año ${date.getFullYear()}`;
    } catch (e) {
        return '';
    }
};

export const getCurrentDateString = (): string => {
    return new Date().toISOString().split('T')[0];
};

export const getCurrentDateDisplay = (): string => {
    return formatDateForDisplay(getCurrentDateString());
};
